import { render, staticRenderFns } from "./DownloadCard.vue?vue&type=template&id=04fc91e1&scoped=true&"
import script from "./DownloadCard.vue?vue&type=script&lang=ts&"
export * from "./DownloadCard.vue?vue&type=script&lang=ts&"
import style0 from "./DownloadCard.vue?vue&type=style&index=0&id=04fc91e1&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04fc91e1",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VCheckbox,VFlex,VLayout,VSelect,VTooltip})
